import { Vendor, vendors } from "../config/vendors";

export default class BaseUrl {
  private readonly environmentMap: Record<string, string> = {
    "d-dtap": "dev",
    "t-dtap": "tst",
    "a-dtap": "acc",
    www: "prod",
  };

  private baseUrl: string;
  private domain: string;
  private subdomain: string;
  private vendor: Vendor;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;

    this.getUrlDetails();
  }

  public getVendor() {
    return this.vendor;
  }

  public getDomain() {
    return this.domain;
  }

  public getSubdomain() {
    return this.subdomain;
  }

  public getEnvironment() {
    return this.environmentMap[this.subdomain] ?? "prod";
  }

  private getUrlDetails() {
    if (!this.validateUrl()) {
      throw new Error("Provided URL is not valid!");
    }

    const fullDomain = this.baseUrl.replace(/https?:\/\//, "").replace("/", "");

    const regPattern =
      /^(((www|((a|d|t)-dtap))\.)?)((b2b\.)?[^\.]+(\.[^\.]{2,4})+)$/g;
    const allMatches = [...fullDomain.matchAll(regPattern)];

    if (allMatches.length === 0) throw new Error("Provided URL is not valid!");

    this.domain = allMatches[0][6];
    this.subdomain = allMatches[0][3] || "";

    this.vendor = vendors.find(
      (vendor) => [vendor.channel, vendor.oldName].indexOf(this.domain) > -1
    );
    if (!this.vendor) {
      throw new Error("vendor is not valid!");
    }
  }

  private validateUrl() {
    try {
      new URL(this.baseUrl);

      const pattern: RegExp = new RegExp("^https?://", "gi");
      if (pattern.test(this.baseUrl)) {
        return true;
      }
    } catch (error) {}

    return false;
  }
}
